<mat-form-field class="allwidth">
    <input matInput placeholder="{{ placeholder ? (placeholder | translate) : ''}}" [value]="selectedItem?.[propertyToShow]" [disabled]="true" class="one">
      <i matSuffix *ngIf="ngControl?.control.enabled || enabled" class="glyphicon glyphicon-new-window link" (click)="selectItem()"></i>
</mat-form-field>
<error [control]="ngControl?.control" [checkForTouched]="false"></error>